<template>
  <div
    class="flex items-center justify-center w-full overflow-hidden group sm:object-scale-down sm:object-center aspect-video sm:rounded-lg bg-slate-100 dark:bg-zinc-800"
  >
    <div class="absolute top-0 z-10 h-full w-128 skeleton-loader"></div>
    <div class="relative z-20 flex flex-col items-center gap-4 dark:text-zinc-300">
      <div class="text-slate-400 dark:text-zinc-900 bg-white dark:bg-zinc-700 p-2.5 rounded-full">
        <Icon name="general.upload" />
      </div>
      <h2 class="text-2xl font-bold" v-if="isEditProcessing && !uploading">Content is being processed</h2>
      <h2 class="text-2xl font-bold" v-else>Content is being uploaded</h2>
      <p class="text-center">
        This may take several minutes.<br />
        If you have any questions, visit our <a href="https://support.zight.com/" class="text-blue-500 underline hover:text-blue-700">support page</a>.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { Icon } from '@/storybook/icon';
const viewerItemStore = useViewerItemStore();
const { isEditProcessing, uploading } = storeToRefs(viewerItemStore);
</script>

<style>
.skeleton-loader {
  animation-name: skeleton-animation;
  animation-duration: 0.8s;
  animation-iteration-count: infinite;
}
.skeleton-loader,
.light .skeleton-loader {
  background: linear-gradient(89.17deg, #f1f5f9 0.8%, #e1e8f0 50.09%, #f1f5f9 96.31%);
}
.dark .skeleton-loader {
  background: linear-gradient(89.17deg, #242d37 0.8%, #293949 50.09%, #242d37 96.31%);
}

@keyframes skeleton-animation {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
</style>
